import { LANGUAGE_LOGOS } from "./LanguageLogos";

type TabLang = keyof typeof LANGUAGE_LOGOS;

/**
 * コードの実行環境の言語タブ (ロゴ + 名前、選んだ札はエディタの地とつながるカード状)。
 * トップの hero、/tools/playground、/visualize の「実際のコード」が同じ見た目を使う
 */
export function LanguageTabs<T extends TabLang>({
  tabs,
  value,
  onChange,
  ariaLabel = "コードの言語",
}: {
  tabs: ReadonlyArray<{ key: T; label: string }>;
  value: T;
  onChange: (key: T) => void;
  /** 読み上げの名前。渡さない呼び出し元は今までどおり日本語 */
  ariaLabel?: string;
}) {
  return (
    <div
      role="group"
      aria-label={ariaLabel}
      className="flex items-center gap-1 border-b border-main bg-third px-2 pt-2 overflow-x-auto scrollbar-hide rounded-t-lg"
    >
      {tabs.map((tab) => {
        const isActive = tab.key === value;
        const Logo = LANGUAGE_LOGOS[tab.key];
        return (
          <button
            key={tab.key}
            type="button"
            aria-pressed={isActive}
            onClick={() => onChange(tab.key)}
            className={`flex items-center gap-1.5 px-2.5 sm:px-3 py-2 text-xs max-sm:text-[15px] max-sm:leading-6 sm:text-sm font-bold rounded-t-lg whitespace-nowrap transition-colors ${
              isActive
                ? "bg-second text-main border-t border-x border-main"
                : "text-sub hover:text-main"
            }`}
          >
            <Logo className="w-4 h-4 sm:w-[18px] sm:h-[18px] shrink-0" />
            <span>{tab.label}</span>
          </button>
        );
      })}
    </div>
  );
}
